module.exports = __webpack_public_path__ + "img/personal.0db9a4e2.jpg";